import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { useSnackbarContext } from '../../context/SnackbarProvider/SnackbarProvider'

const updateStrategy = async ({ strategyId, strategyData }) => {
  const url = `${baseUrl}/aws/updatestrategy/${strategyId}`
  const response = await axios.put(url, strategyData)
  return response.data
}

const useSaveStrategy = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  const mutation = useMutation({
    mutationFn: updateStrategy,
    onMutate: async ({ strategyId, strategyData }) => {
      await queryClient.cancelQueries({ queryKey: ['/aws/strategy', strategyId] })
      const previousStrategy = queryClient.getQueryData(['/aws/strategy', strategyId])

      // queryClient.setQueryData(['/aws/strategy', strategyId], old => ({
      //   ...old,
      //   ...strategyData,
      // }))

      return { previousStrategy }
    },
    onError: (err, { strategyId }, context) => {
      queryClient.setQueryData(['/aws/strategy', strategyId], context.previousStrategy)
      console.error('Mutation Error:', err)
      showSnackbar((err as any).response?.data?.message || err.message, 'error')
    },
    onSuccess: (_, { strategyId }) => {
      // queryClient.invalidateQueries({ queryKey: ['/aws/strategy', strategyId] })
      // queryClient.invalidateQueries({ queryKey: ['/aws/organizations'] })
      showSnackbar('Strategy updated successfully', 'success')
    },
  })

  return mutation
}

export default useSaveStrategy
